import React from "react";

interface HowItWorksStep {
  title: string;
  description: string;
}

interface HowItWorksProps {
  steps: HowItWorksStep[];
  heading?: string;
  className?: string;
}

const HowItWorks: React.FC<HowItWorksProps> = ({
  steps,
  heading = "How It Works",
  className = "",
}) => (
  <section className={`container bg-[#c3d3ab] mx-auto px-4 py-4 ${className}`}>
    <div className="max-w-4xl mx-auto">
      <h2 className="font-mono text-3xl text-[#b05e2c] mb-6 text-center">
        {heading}
      </h2>
      <div
        className={`grid gap-8 ${
          steps.length < 3
            ? "md:grid-cols-2"
            : `md:grid-cols-${Math.min(steps.length, 4)}`
        }`}
      >
        {steps.map((step, idx) => (
          <div className="text-center" key={idx}>
            <div className="bg-green-800 text-white w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4 text-2xl">
              {idx + 1}
            </div>
            <h3 className="font-mono text-xl mb-2">{step.title}</h3>
            <p className="text-gray-600">{step.description}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default HowItWorks;